var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-container',{staticClass:"MaxContainerBox"},[_c('el-header',[_c('Header')],1),_c('el-container',{staticClass:"bottomContainer"},[_c('el-aside',{class:!_vm.getisCollapse ? 'collapse-slide' : ''},[_c('Aside')],1),_c('el-main',[_c('Main')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }